import BaseComponent from '@/components/base';
import quantityInputStyle from '@/components/quantity-input/style';
import MinusButton from '@/components/minus-button';
import plusButton from '@/components/plus-button';

export default class QuantityInputBasic extends BaseComponent {
  onConstruct() {
    this._onChangeHandler = () => {};
  }

  render() {
    return `
    ${quantityInputStyle()}
        <div class="cart-quantity-container">
            <button class="quantity-button quantity-button-minus" name="minus" type="button" data-button="minus">
              ${MinusButton()}
            </button>
            <input
              class="quantity-input"
              data-product-handle="${this.itemHandle}"
              type="number"
              name="updates[]"
              value="${this.itemQuantity}"
              min="1"
              data-cart-quantity="${this.itemQuantity}"
            >
            <button class="quantity-button quantity-button-plus" name="plus" type="button" data-button="plus">
               ${plusButton()}
            </button>
          </div>`;
  }

  async handleChangeQuantity(addQuantity) {
    const productQuantityValue = Number(this.quantityInputField.value);
    const newProductQuantity = productQuantityValue + addQuantity;
    if (newProductQuantity >= 1) {
      this.quantityInputField.value = `${newProductQuantity}`;
      this.quantityInputField.setAttribute(
        'data-cart-quantity',
        `${newProductQuantity}`
      );
    }
    this._onChangeHandler(newProductQuantity, productQuantityValue);
  }

  async handleChangeQuantityInput(value) {
    const newProductQuantity = Number(value);
    if (newProductQuantity >= 1) {
      this.quantityInputField.value = `${newProductQuantity}`;
      this.quantityInputField.setAttribute(
        'data-cart-quantity',
        `${newProductQuantity}`
      );
    } else {
      this.quantityInputField.value = '1';
      this.quantityInputField.setAttribute('data-cart-quantity', '1');
    }
    this._onChangeHandler(newProductQuantity);
  }

  connectedCallback() {
    this.connectChangeQuantityButtons();
    this.connectChangeInputQuantity();
  }

  connectChangeInputQuantity() {
    const inputQuantity = this.shadowRoot.querySelector('[data-cart-quantity]');

    inputQuantity.addEventListener('blur', (e) =>
      this.handleChangeQuantityInput(e.target.value)
    );
  }

  connectChangeQuantityButtons() {
    const buttonPlus = this.shadowRoot.querySelector('[data-button="plus"]');
    const buttonMinus = this.shadowRoot.querySelector('[data-button="minus"]');
    buttonPlus.addEventListener('click', () => this.handleChangeQuantity(+1));
    buttonMinus.addEventListener('click', () => this.handleChangeQuantity(-1));
  }

  get itemQuantity() {
    return this.getAttribute('quantity');
  }

  get itemHandle() {
    return this.getAttribute('handle');
  }

  get quantityInputField() {
    return this.shadowRoot.querySelector('[data-cart-quantity]');
  }

  set onChangeHandler(fn) {
    this._onChangeHandler = fn;
  }
}
